module.exports = __webpack_public_path__ + "static/media/iconfinder_cloud_text_1814099.67b87c57.png";